import React, { useState, useEffect } from "react"
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import ButtonGroup  from '@material-ui/core/ButtonGroup'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ArrowDropDownCircle from "@material-ui/icons/ArrowDropDownCircle"
import TextField from '@material-ui/core/TextField'
import SaveIcon from '@material-ui/icons/Save'
import LabelIcon from '@material-ui/icons/Label';
import axios from 'axios'
import { useToEdit, useSelectedSOPs, setSelectedSOPs, setUpdateSOPs, usePlan } from '../redux/plan'
import { useRoles, useName, useToken } from '../redux/auth'
import { EditorConvertToHTML } from './myeditor'
import { getSOPS, getSOPforReplacement, baseURL, api, getAttachments, updatePlanSops } from '../modules/db'
import { setSelectedModule, setChanges, setOpenDialog } from '../redux/navigation'
import Auto from '../components/autotags'
import NewTagDialog from '../components/newtagdialog'
import LiveHelpTwoToneIcon from '@material-ui/icons/LiveHelpTwoTone'
import UploadFile from './uploadfiledialog'
import { editorType as docType } from "./creator"
import CCPEditor from './creator/CCPEditor'
import TitleEditor from './creator/TitleEditor'
import HazardStepsEditor from './creator/HazardStepsEditor'
import HazardsInputsEditor from './creator/HazardsInputsEditor'
import { validate as gloValidate } from "./creator/utils"
import { theme } from "../theme";


const Editor =  () => {
    const {colors} = theme
    const token = useToken()
    const currPlan = usePlan()
    if(!currPlan._id){
        const localPlan = JSON.parse(localStorage.getItem("plan"))
        if(localPlan && localPlan.plan){
            console.log("local._id "+localPlan.plan._id)
            currPlan._id = localPlan.plan._id
            currPlan._rev = localPlan.plan._rev
        }
        
    
    }
    const [attachments, setAttachments] = useState({})
    const [openTagDialog, setOpenTagDialog] = useState(false)
    const toEdit = useToEdit()
    const [sopState, setSopState] = useState(toEdit.data)
    const [clicked, setCliked] = useState(false)
    const [useCriteria, setCriteria] = useState(toEdit.doctype === docType.sop ? toEdit.data.criteriaandinstructions : '')
    const [useMonitoring, setMonitoring] = useState(toEdit.doctype === docType.sop ? toEdit.data.monitoring : '')
    const [useResponsibilities, setResponsibilities] = useState(toEdit.doctype === docType.sop ? toEdit.data.responsibilities : '')
    const [usePurpose, setPurpose] = useState(toEdit.doctype === docType.sop ? toEdit.data.purposeandintroduction : '')
    const [useCorrective, setCorrective] = useState(toEdit.doctype === docType.sop ? toEdit.data.correctiveactions : '')
    const [useVerification, setVerification] = useState(toEdit.doctype === docType.sop ? toEdit.data.verificationandrecordkeeping : '')
    const [useDoc, setDoc] = useState(toEdit.doctype === docType.doc ? toEdit.data.text: '')
    const [useRecords, setRecords] = useState( toEdit?.data?.records ? toEdit.data.records : '' )
    const [useVal, setVal] = useState(false)
    const sops = useSelectedSOPs()
    const roles = useRoles()
    const name = useName()
    const [editorType] = useState(toEdit.doctype === docType.sop ? false : true)
    const [uploadOpen, setUploadOpen] = useState(false)
    const [activeSection, setActiveSection] = useState('records')
    
    useEffect( () => {
        async function getAttach(){
            const att = await getAttachments(token)
            setAttachments(att)
        }
        getAttach()
    }, [])


    const upTags = (tag, val) => {
        setChanges(true)
        let res = {...sopState}
        if(!res.hasOwnProperty('humantags')){
            res['humantags']={}
        } else{
            res.humantags[tag]=val 
        }
        setSopState(res)
        //localStorage.setItem('localSOP', JSON.stringify(res))
    }

    const handleDeleteClick = (sop) => {
        removeFromSelected(sop._id)
        alert(`Your ${toEdit.doctype} proposal was sucessfully deleted from this session's plan`)
        setSelectedModule('Organize')
    }
    
    const handleSaveClick = (sop) => {
        if(!clicked){
            setOpenDialog(
                {
                    open:true, 
                    txt:`Are you sure you want to save this ${toEdit.doctype} as new?`,
                    pos : async () => {
                        saveProcess(sop)
                        setCliked(true)
                        setOpenDialog({open:false, txt:'',neg:null,pos:null})
                    },
                    neg : () => setOpenDialog({open:false, txt:'',neg:null,pos:null})
                }
            ) 
            
        }
    }

    const handleRejectClick = async (sop) => {
        setOpenDialog(
            {
                open:true, 
                txt:'Are you sure you want to delete this from the DB?',
                pos : async () => {
                removeFromSelected(sop._id)
                var Rej = {...sop}
                Rej['type']='archivedSOP'
                Rej.updated = new Date()
                const result = await axios.post(
                    `${api}/sopsqav2`, Rej, 
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    },
                )
                await getSOPS(token);
                alert(`Your ${toEdit.doctype} was sucessfully deleted from the DB`)
                setSelectedModule('Find')
                setOpenDialog({open:false, txt:'',neg:null,pos:null})
                return result
                },
                neg : () => {
                setOpenDialog({open:false, txt:'',neg:null,pos:null})
                }
            }
        ) 
    }

    const saveProcess = async (sop) => {
        const val = validate(sop)
        
        if(val.empty.length === 0){
            var nu = {...val.newSop}
            nu['basedonsop']=sop._id
            roles.includes('admin') ? nu['type']='approved':nu['type']='proposal'
            roles.includes('admin') ? setUpdateSOPs(true) : setUpdateSOPs(false)
            nu['writer']=name
            delete nu['_rev']
            delete nu['_id']
            await saveSOP(nu)
            
        } else {
            alert('You need to fill the following fields:   \n' + val.empty.join(', \n')) 
            if(val.tags){
                alert('You need to fill all your tags')
            }
        }
    }
    
    const saveSOP = async (doc, updatePlan = false) =>  {
        doc.updated = new Date()
        const result = await axios.post(
            `${api}/sopsqav2`, doc, 
            {
                headers: { Authorization: `Bearer ${token}` }
            },
        )
        alert('Your changes to ' +doc.title + ' were sucessfully saved')
        const res={...doc}
        res['_id']=result.data[0]._id
        res['_rev']=result.data[0]._rev
        //console.log("sops in editor "+JSON.stringify(sops))
        setSelectedSOPs(sops) 
        currPlan.sops=sops;
        if(updatePlan)
            await updatePlanSops(token, doc, currPlan)
        //getSOPS(token)
        setSelectedModule('Organize')
        return res
    }
    
    const removeFromSelected = (theid) => {
        const filtered = sops.filter(
            (e) => {
                return e._id !== theid
            }
        )
        console.log(filtered)
        setSelectedSOPs(filtered)
        return filtered
    }

    const handleReplacement = () => {
        const sop = {...sopState}
        const val = validate(sop)
        if(val.empty.length === 0){
            setOpenDialog(
                {
                    open:true, 
                    txt:`Are you sure you want to update this ${toEdit.doctype}?`,
                    pos : async () => {
                        let Rep = {...val.newSop}
                        Rep['type']='approved'
                        Rep['criteriaandinstructions']=useCriteria
                        Rep['monitoring']=useMonitoring
                        Rep['responsibilities']=useResponsibilities
                        Rep['purposeandintroduction']=usePurpose
                        Rep['correctiveactions']=useCorrective
                        Rep['verificationandrecordkeeping']=useVerification
                        Rep['writer']=name
                        await saveSOP(Rep, true)
                        setOpenDialog({open:false, txt:'',neg:null,pos:null})
                    },
                    neg : () => setOpenDialog({open:false, txt:'',neg:null,pos:null})
                }
            ) 
        } else {
            alert('You need to fill the following fields:   \n' + val.empty.join(', \n')) 
            if(val.tags){
                alert('You need to fill all your tags')
            }
        }
    }
    
    const handleFormChange = (event) => {
        let res = {...sopState}
        res[event.target.id]=event.target.value
        if(!res["biological_hazard"]){           
            let masterDoc = res["masterDoc"]?res["masterDoc"]:"";
            let typeOfDoc = res["typeOfDoc"]?res["typeOfDoc"]:"";
            let documentKey = res["documentKey"]?res["documentKey"]:"";
            let name = res["name"]?res["name"]:"";
            res["title"]=masterDoc+"-"+typeOfDoc+"-"+documentKey+" "+name;
        }
        
        //console.log("form change "+JSON.stringify(res["title"]))
        setSopState(res)
    }

    const validate = () => {
        var sop = { ...sopState }
        roles.includes('admin') ? sop['type']='approved' : sop['type']='proposal'
        sop['writer']=name
        sop['status']=sop.type
        if (toEdit.doctype === docType.sop){
            sop['monitoring']=useMonitoring
            sop['criteriaandinstructions']=useCriteria
            sop['responsibilities']=useResponsibilities
            sop['purposeandintroduction']=usePurpose
            sop['correctiveactions']=useCorrective
            sop['verificationandrecordkeeping']=useVerification
            sop['records'] = useRecords
            sop['doctype']=docType.sop
        } else {
            sop['text'] = useDoc
            sop['records'] = useRecords
            sop['doctype']=docType.doc
        }
        return gloValidate(sop, roles, name, safeDoctype)
    }
   
    const TagSelector = () => {
        return(
            <>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="AR" 
                        value={sopState.humantags ? sopState.humantags.AR : ''}
                        title={"Audit Requirements"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'AR'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="LOC" 
                        value={sopState.humantags ? sopState.humantags.LOC : ''}
                        title={"Locations"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'LOC'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="DOC" 
                        value={sopState.humantags ? sopState.humantags.DOC : ''}
                        title={"Document type"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'DOC'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="PR" 
                        value={sopState.humantags ? sopState.humantags.PR : ''}
                        title={"Process"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'PR'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="ING" 
                        value={sopState.humantags ? sopState.humantags.ING : ''}
                        title={"Ingredients"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'ING'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="PRS" 
                        value={sopState.humantags ? sopState.humantags.PRS : ''}
                        title={"Process Step"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'PRS'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="EQU" 
                        value={sopState.humantags ? sopState.humantags.EQU : ''}
                        title={"Equipment"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'EQU'}
                    />
                </div>
                <div 
                    style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                >
                    <Auto 
                        id="PAC" 
                        value={sopState.humantags ? sopState.humantags.PAC : ''}
                        title={"Packaging material type"} 
                        updateProcess={upTags} 
                        type={'Tags'}
                        tag={'PAC'}
                    />
                </div>
            </>
        )
    }

    const safeDoctype = (toEdit.hasOwnProperty('doctype') && toEdit.doctype !== null) ? toEdit.doctype : toEdit.hasOwnProperty('text') ? docType.doc : docType.sop
    const { monitoring, 
        criteriaandinstructions, 
        responsibilities, 
        purposeandintroduction, 
        correctiveactions, 
        verificationandrecordkeeping,
        records,
        text  } = safeDoctype == editorType.sop ? { ... attachments?.attachments?.sop } : { ... attachments?.attachments?.doc }

    const editorView = (doctype) => {
        switch(doctype){
            case docType.hi:
                return (
                    <HazardsInputsEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        attachments={attachments}
                    >
                        <TagSelector />
                    </HazardsInputsEditor>
                )
            case docType.hs:
                return (
                    <HazardStepsEditor
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        attachments={attachments}
                    >
                        <TagSelector />
                    </HazardStepsEditor>
                )
            case docType.ccp:
                return(
                    <CCPEditor 
                        handleFormChange={handleFormChange}
                        setActiveSection={setActiveSection}
                        setUploadOpen={setUploadOpen}
                        sopState={sopState}
                        setSopState={setSopState}
                        attachments={attachments}
                    >
                        <TagSelector />
                    </CCPEditor>
                )
            case docType.doc:
                return(
                    <div>
                        <form noValidate autoComplete="off">
                            <div>
                                <TitleEditor  id="titleEditor"
                                handleFormChange={handleFormChange}
                                setActiveSection={setActiveSection}
                                setUploadOpen={setUploadOpen}
                                sopState={sopState}
                                setSopState={setSopState}
                                />
                            </div>
                            <div>
                                <TextField id="title" label="Title" value={sopState.title} 
                                onChange={(e) => handleFormChange(e)} 
                                style={{width:'80%', marginBottom:20}}
                                />
                            </div>
                            
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof text !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("text")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Document content</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        <EditorConvertToHTML html={useDoc} update={setDoc}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header-records"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof records !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("records")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Records</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        <EditorConvertToHTML html={useRecords} update={setRecords}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="AR" 
                                    value={sopState.humantags ? sopState.humantags.AR : ''}
                                    title={"Audit Requirements"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'AR'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="LOC" 
                                    value={sopState.humantags ? sopState.humantags.LOC : ''}
                                    title={"Locations"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'LOC'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="DOC" 
                                    value={sopState.humantags ? sopState.humantags.DOC : ''}
                                    title={"Document type"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'DOC'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="PR" 
                                    value={sopState.humantags ? sopState.humantags.PR : ''}
                                    title={"Process"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'PR'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="ING" 
                                    value={sopState.humantags ? sopState.humantags.ING : ''}
                                    title={"Ingredients"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'ING'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="PRS" 
                                    value={sopState.humantags ? sopState.humantags.PRS : ''}
                                    title={"Process Step"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'PRS'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="EQU" 
                                    value={sopState.humantags ? sopState.humantags.EQU : ''}
                                    title={"Equipment"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'EQU'}
                                />
                            </div>
                            <div 
                                style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                            >
                                <Auto 
                                    id="PAC" 
                                    value={sopState.humantags ? sopState.humantags.PAC : ''}
                                    title={"Packaging material type"} 
                                    updateProcess={upTags} 
                                    type={'Tags'}
                                    tag={'PAC'}
                                />
                            </div>
                        </form>
                    </div>
                )
            default:
                return(
                    <div>
                        <form noValidate autoComplete="off">
                        <div>
                                <TitleEditor  id="titleEditor"
                                handleFormChange={handleFormChange}
                                setActiveSection={setActiveSection}
                                setUploadOpen={setUploadOpen}
                                sopState={sopState}
                                setSopState={setSopState}
                                />
                            </div>
                            <div>
                                <TextField id="title" label="Title" value={sopState.title} 
                                onChange={(e) => handleFormChange(e)} 
                                style={{width:'80%', marginBottom:20}}
                                />
                            </div>
                            
                            
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof purposeandintroduction !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("purposeandintroduction")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Purpose and Introduction</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        <EditorConvertToHTML html={usePurpose} update={setPurpose}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof criteriaandinstructions !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("criteriaandinstructions")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Criteria and Instructions</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        
                                        <EditorConvertToHTML html={useCriteria} update={setCriteria}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div>
                                <TextField id="frequency" label="Frequency" value={sopState.frequency} 
                                    onChange={(e) => handleFormChange(e)}
                                    style={{width:'80%', marginBottom:20}} multiline rowsMax={4} 
                                />
                            </div>
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof responsibilities !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("responsibilities")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Responsibilities</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                                        <EditorConvertToHTML html={useResponsibilities} update={setResponsibilities} />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof monitoring !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("monitoring")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Monitoring</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                                        <EditorConvertToHTML html={useMonitoring} update={setMonitoring} />
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof correctiveactions !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("correctiveactions")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Corrective actions</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        <EditorConvertToHTML html={useCorrective} update={setCorrective}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof verificationandrecordkeeping !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("verificationandrecordkeeping")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Verification and record keeping</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:350, overflow:'hidden'  }}>
                                        <EditorConvertToHTML html={useVerification} update={setVerification}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div style={{ width:'90%', paddingLeft:'10%', paddingBottom:30 }}>
                                <ExpansionPanel>
                                    <ExpansionPanelSummary
                                        expandIcon={<ArrowDropDownCircle />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header-records"
                                    >
                                        <LiveHelpTwoToneIcon style={{ color: typeof records !== 'undefined' ? 'green' : 'gray', }}
                                            onClick={ () => {
                                                setActiveSection("records")
                                                setUploadOpen(true)
                                            }}
                                        />
                                        <h3>Records</h3>
                                    </ExpansionPanelSummary>
                                    <ExpansionPanelDetails style={{ marginLeft:'5%', marginRight:'5%', minHeight:300}}>
                                        <EditorConvertToHTML html={useRecords} update={setRecords}/>
                                    </ExpansionPanelDetails>
                                </ExpansionPanel>
                            </div>
                            <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="AR" 
                                value={sopState.humantags ? sopState.humantags.AR : ''}
                                title={"Audit Requirements"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'AR'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="LOC" 
                                value={sopState.humantags ? sopState.humantags.LOC : ''}
                                title={"Locations"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'LOC'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="DOC" 
                                value={sopState.humantags ? sopState.humantags.DOC : ''}
                                title={"Document type"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'DOC'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PR" 
                                value={sopState.humantags ? sopState.humantags.PR : ''}
                                title={"Process"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PR'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="ING" 
                                value={sopState.humantags ? sopState.humantags.ING : ''}
                                title={"Ingredients"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'ING'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PRS" 
                                value={sopState.humantags ? sopState.humantags.PRS : ''}
                                title={"Process Step"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PRS'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="EQU" 
                                value={sopState.humantags ? sopState.humantags.EQU : ''}
                                title={"Equipment"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'EQU'}
                             />
                        </div>
                        <div 
                            style={{width:'90%', marginBottom:20, paddingLeft:'10%'}}
                        >
                            <Auto 
                                id="PAC" 
                                value={sopState.humantags ? sopState.humantags.PAC : ''}
                                title={"Packaging material type"} 
                                updateProcess={upTags} 
                                type={'Tags'}
                                tag={'PAC'}
                             />
                        </div>
                        </form>
                    </div>
                )
        }
    }
    return (
        <Paper elevation={3} style={{paddingTop:100, paddingBottom:50}} >
            <UploadFile 
                isOpen={uploadOpen} 
                onClose={()=>setUploadOpen(false)} 
                section={activeSection}
                attachments={attachments}
                sopId={sopState._id}
                doctype={safeDoctype}
                updateAttachments={setAttachments}
            />
            <NewTagDialog isOpen={openTagDialog} onClose={() => setOpenTagDialog(false)} /> 
            <p>Writer: {sopState.writer}</p>
            
            {editorView(toEdit.doctype)}
            { roles.includes('admin') ?
                <ButtonGroup variant="contained">
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<SaveIcon />}
                    onClick={() => { handleSaveClick(sopState) }}
                    style={{ 
                    backgroundColor: colors.secondary,
                    color:'white'
                    }}
                >
                    Save as new
                </Button>
                {
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<SaveIcon />}
                        onClick={() => { handleReplacement(sopState ) }}
                        style={{ 
                        backgroundColor: colors.secondary,
                        color:'white'
                        }}
                    >
                        Update
                    </Button>
                }
                <Button
                    variant="contained"
                    size="large"
                    startIcon={<SaveIcon />}
                    onClick={() => { handleRejectClick(sopState) }}
                    style={{ 
                    backgroundColor: colors.secondary,
                    color:'white'
                    }}
                >
                    Delete this {toEdit.doctype} from the DB
                </Button>

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<LabelIcon />}
                    onClick={() => { setOpenTagDialog(true) }}
                    style={{ 
                    backgroundColor: colors.secondary,
                    color:'white'
                    }}
                >
                    New Tag
                </Button>

                <Button
                    variant="contained"
                    size="large"
                    startIcon={<SaveIcon />}
                    onClick={() => { handleDeleteClick(sopState, sops) }}
                    style={{ 
                    backgroundColor: colors.secondary,
                    color:'white'
                    }}
                >
                    Delete from plan
                </Button>
            </ButtonGroup>:
            <ButtonGroup variant="contained">
            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { 
                    handleSaveClick(
                        sopState, 
                        useCriteria, 
                        useMonitoring, 
                        useResponsibilities,
                        useCorrective,
                        usePurpose
                    ) 
                }}
                style={{ 
                backgroundColor: colors.secondary,
                color:'white'
                }}
            >
                Save
            </Button>
            <Button
                variant="contained"
                size="large"
                startIcon={<SaveIcon />}
                onClick={() => { handleDeleteClick(sopState) }}
                style={{ 
                backgroundColor: colors.secondary,
                color:'white'
                }}
            >
                Delete from plan
            </Button>
        </ButtonGroup>
            }
        </Paper>
    )
}
export default Editor
